var _path, _path2, _path3, _g, _path4, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 817,
    height: 744,
    viewBox: "0 0 817 744",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.715 18.6602H18.0225C9.4537 18.6602 3.64615 27.3823 6.95087 35.2882L300.116 736.63C301.983 741.095 306.348 744.002 311.188 744.002H548.236C553.171 744.002 557.603 740.98 559.406 736.385L651.102 502.724C652.337 499.578 652.188 496.057 650.691 493.027L544.618 278.23C540.083 269.047 526.87 269.399 522.831 278.811L434.668 484.242C430.438 494.099 416.388 493.878 412.47 483.893L232.886 26.2764C231.083 21.6821 226.651 18.6602 221.715 18.6602Z",
    fill: "#F37B2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.939 18.6562H32.9431C17.2792 18.6562 6.663 34.6004 12.7041 49.0525L297.563 730.522C300.974 738.684 308.955 743.998 317.802 743.998H541.459C550.481 743.998 558.583 738.474 561.879 730.075L649.495 506.81C651.752 501.059 651.479 494.623 648.744 489.084L554.157 297.547C545.868 280.761 521.714 281.405 514.331 298.609L444.207 462.005C436.475 480.023 410.792 479.619 403.629 461.367L235.359 32.5789C232.063 24.1803 223.961 18.6562 214.939 18.6562Z",
    fill: "#F37B2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4886_73651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 647,
    height: 744
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.432 0H32.6385C16.8199 0 6.09883 16.3543 12.1996 31.1781L299.872 730.177C303.318 738.549 311.377 744 320.311 744H546.178C555.289 744 563.471 738.334 566.8 729.719L655.281 500.711C657.561 494.812 657.285 488.21 654.522 482.529L559.001 286.065C550.63 268.847 526.238 269.508 518.781 287.154L447.965 454.753C440.156 473.234 414.22 472.82 406.986 454.099L237.054 14.2808C233.725 5.66616 225.543 0 216.432 0Z",
    fill: "#F37B2F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4886_73651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.136 -11.48L886.098 363.456L648.09 942.966L300 811L641.136 -11.48Z",
    fill: "#355935"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M680.299 0C606.183 0 545.754 60.473 545.754 134.968C545.754 203.913 598.465 261.611 665.593 269.06C667.194 298.42 663.075 340.313 640.651 366.168C635.264 372.157 635.991 381.359 641.961 386.764C644.728 389.101 648.223 390.269 651.572 390.269C655.212 390.269 658.852 388.954 661.765 386.179C662.929 385.449 665.987 384.426 667.734 383.696C670.647 382.674 673.122 381.797 675.015 380.775C733.551 350.977 772.325 292.87 795.477 242.622C808.873 213.408 816.299 179.228 816.299 147.092C816.299 142.71 816.154 138.327 815.862 133.946C811.058 60.0344 750.337 0 680.299 0Z",
    fill: "#355935"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 680.933,
    cy: 130.703,
    r: 66.7223,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo1.0a30d8b261e5ff1f19a645a00251d4a6.svg";
export { ForwardRef as ReactComponent };